import { parseISO } from "date-fns";

export const isValidIsoDate = (str: string) => {
	const date = parseISO(str);
	return String(date) !== "Invalid Date" && !isNaN(date.getTime());
};
